export function LiveIndicator({ label = 'Live', className = '' }: { label?: string | null; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className="h-2 w-2 rounded-full bg-red animate-pulseDot" aria-hidden="true" />
      {label && <span className="text-[12px] font-semibold uppercase tracking-[0.06em] text-red">{label}</span>}
    </span>
  );
}
